import React, { useEffect } from 'react'
import { ApiResponse } from '../../typings/ApiResponse'
import { IPickingRoute } from '../../interfaces/PickingRoute/PickingRoute'
import { useApi } from '../../hooks/useApi'
import { ApiConfig } from '../../config/api'
import axios from 'axios'
import { PickingAlertButton } from './PickingAlertButton'

interface PickingRouteAlertsProps {
  onClickAlert: () => void
}

export const getPickingRoutesWithoutStock = () => {
  const url = new URL(
    `${ApiConfig.PickingRouteAdminApi}?pageIndex=0&pageSize=5&pickingRouteStateId=3&validationStatusId=2&isIncomplete=true`
  )
  url.searchParams.set('pickingRouteStateId', '3')
  url.searchParams.set('validationStatusId', '2')
  url.searchParams.set('isIncomplete', true.toString())
  url.searchParams.set('pageIndex', '0')
  url.searchParams.set('pageSize', '1')
  return axios.get(url.toString())
}

export const PickingRouteAlert: React.FC<PickingRouteAlertsProps> = ({
  onClickAlert
}) => {
  const { state, callApi } = useApi<ApiResponse<IPickingRoute>>()

  const fetchPickingRoutesWithoutStock = () => {
    callApi(getPickingRoutesWithoutStock())
  }

  useEffect(() => {
    fetchPickingRoutesWithoutStock()
  }, [])

  const decideValueToAlert = (totalQuantity: number | undefined) => {
    if (totalQuantity === undefined) {
      return '0 Rutas'
    }

    if (totalQuantity === 1) {
      return '1 Ruta'
    }

    if (totalQuantity > 100) {
      return '+99 Rutas'
    }

    return `${totalQuantity.toString()} Rutas`
  }

  return (
    <PickingAlertButton
      title={decideValueToAlert(state.data?.totalItems)}
      onClick={onClickAlert}
    />
  )
}
